import { createContext, useContext, useState } from 'react';
import { ApplyRefinModal } from '@/modals/ApplyRefinModal';

const RefinContext = createContext();

export const RefinProvider = ({ disableReload = false, children }) => {
  const [modal, setModal] = useState(null);

  const onApply = data => {
    setModal({ type: 'apply', data });
  };

  const onRefinSuccess = () => {
    setModal(null);
    !disableReload && setTimeout(() => {
      window.location.reload();
    }, 1000);
  };

  const value = {
    onApply,
  };

  return (
    <RefinContext.Provider value={value}>
      {children}
      {modal?.type === 'apply' && (
        <ApplyRefinModal
          loan={modal.data}
          onSuccess={onRefinSuccess}
          onClose={() => setModal(null)}
        />
      )}
    </RefinContext.Provider>
  );
};

export const useRefin = () => useContext(RefinContext);
